// extracted by mini-css-extract-plugin
var _1 = "input_error__2gw9F";
var _2 = "input_formInput__38zEd";
var _3 = "input_formInputLabel__u4J4f";
var _4 = "input_formInputSpan__gV68M";
var _5 = "input_formInputSpanError__FtSSs";
export { _1 as "error", _2 as "formInput", _3 as "formInputLabel", _4 as "formInputSpan", _5 as "formInputSpanError" }
